var ServicePartnerSearchJS = (function ($) {

    function showServicePartnerSearchTab(theme) {
        if(theme === "rdlite") {
            $(".third-tab").css("display", "inline");
            $(".service-partner-footer-search-form").css("display", "none");
            $(".second-tab").css("float", "unset");

            $(".tabmain").addClass("service-partner-search-tab");
            $("#tabblock").addClass("service-partner-search-tab");
        }

        if(theme === "tirendo") {
            $(".servicePartnerSearchButton").css("display", "none");

            $(".tab3-PKW").css("display", "block");
            $(".tab3-MO").css("display", "block");

            $(".tab1-radio-PKW").css("display", "block");
            $(".tab2-radio-PKW").css("display", "block");
            $(".tab3-radio-PKW").css("display", "block");

            $(".tab1-radio-MO").css("display", "block");
            $(".tab2-radio-MO").css("display", "block");
            $(".tab3-radio-MO").css("display", "block");

            $(".switch-wrapper__label").css("display", "none");
            $(".switch-wrapper__slider").css("display", "none");
            $("#swich-filter-PKW").attr("disabled", "disabled");
            $("#swich-filter-MO").attr("disabled", "disabled");
        }

    }

    function hideServicePartnerSearchTab(theme) {
        if(theme === "rdlite") {
            $(".third-tab").css("display", "none");
            $(".second-tab").css("float", "right");
            $(".service-partner-footer-search-form").css("display", "block");

            $(".tabmain").removeClass("service-partner-search-tab");
            $("#tabblock").removeClass("service-partner-search-tab");

            if($('#tab3:checked').length > 0) {
                $("#tab1").prop('checked', true);
            }
        }

        if(theme === "tirendo") {
            $(".servicePartnerSearchButton").css("display", "block");

            $(".tab3-PKW").css("display", "none");
            $(".tab3-MO").css("display", "none");

            $(".tab1-radio-PKW").css("display", "none");
            $(".tab2-radio-PKW").css("display", "none");
            $(".tab3-radio-PKW").css("display", "none");

            $(".tab1-radio-MO").css("display", "none");
            $(".tab2-radio-MO").css("display", "none");
            $(".tab3-radio-MO").css("display", "none");


            $(".switch-wrapper__label").css("display", "block");
            $(".switch-wrapper__slider").css("display", "block");
            $("#swich-filter-PKW").removeAttr('disabled');
            $("#swich-filter-MO").removeAttr('disabled');
        }
    }

    function onServicePartnerFormSubmit() {
        var zipCode = $('#zip-code-service-partner').val();
        var location = $('#location-service-partner').val();
        var cityOrZipCode = zipCode !== "" ? zipCode : location !== "" ? location : "";
        $('#cityOrZipCode').val(cityOrZipCode);
        $('#servicePartnersSearchTabForm').submit();
        }

    function disableInput() {
        var zipCode = $('#zip-code-service-partner').val();
        var location = $('#location-service-partner').val();

        if(zipCode !== "") {
            $('#location-service-partner').attr('disabled', true);
            $('#p-location').attr('style','color:rgba(118, 118, 118, 0.3)');
        }
        else {
            $('#location-service-partner').attr('disabled', false);
            $('#p-location').attr('style','color:#373737;');
        }
        if(location !== "") {
            $('#zip-code-service-partner').attr('disabled', true);
            $('#p-zip-code').attr('style','color:rgba(118, 118, 118, 0.3)');
        }
            else {
            $('#zip-code-service-partner').attr('disabled', false);
            $('#p-zip-code').attr('style','color:#373737;');
        }

    }

    return {
        showServicePartnerSearchTab:showServicePartnerSearchTab,
        hideServicePartnerSearchTab : hideServicePartnerSearchTab,
        onServicePartnerFormSubmit : onServicePartnerFormSubmit,
        disableInput: disableInput
    }

})($);

$(document).ready(function() {
   $('#service-partner-search-button').on('click', function () {
       ServicePartnerSearchJS.onServicePartnerFormSubmit();
    });
    $('#zip-code-service-partner').change(function()  {
        ServicePartnerSearchJS.disableInput();
    });
    $('#location-service-partner').change(function()  {
        ServicePartnerSearchJS.disableInput();
    });
});

